module.exports = __webpack_public_path__ + "media/images/sort_asc-9326ad44.png";